import React from 'react'
import PropTypes from 'prop-types'
import services from '../../../services'
import { withRouter } from 'next/router'
import { inject, observer } from 'mobx-react'
import { APIURL, PAGEURL, MSG } from '../../../../constants'
import AdminDataTable from '../../AdminDataTable'
import PageContentLoader from '../../../loaders/PageContentLoader'
import { toast } from 'react-toastify'
import Permissions from '../../Permissions'

import { AdminButton } from '/components/theme/admin/AdminButton'
import {
  H1,
  ActionColumn
} from '/components/theme/admin/common'
import {
  AdminActionRow,
  AdminEdit,
  AdminDelete
} from '/components/theme/admin/AdminActions'

toast.configure()

@inject('store')
@observer
class FaqMgnt extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page_size: 10,
      next: null,
      prev: null,
      data_table: {},
      filtered_data: null,
      active_page: 1,
      totalItemsCount: 0,
      pageNumber: 1,
      loading: true,
      loading_data: false,
      permissions: {}
    }
  }

  getFaqs = async (product_id, page = 1) => {
    try {
      const res = await services.get_v2(APIURL.API_ADMIN_PRODUCT_FAQ, {
        params: {
          size: this.state.page_size,
          page: page,
          product_id
        }
      })
      return res
    } catch (e) {
      console.error(e)
    }
  }

  deleteFaq = async (faq_id) => {
    try {
      const res = await services.delete_v2(
        APIURL.API_ADMIN_PRODUCT_FAQ_DETAIL(faq_id)
      )
      if (res.statusCode === 200) {
        await this.reload()
        toast('FAQ successfully deleted')
      } else {
        toast.error('Could not delete FAQ')
      }
      return res
    } catch (e) {
      console.error(e)
    }
  }

  reload = async () => {
    try {
      this.setState({
        loading: true
      })
      const product_id = this.props.router.query.id
      const faqs = await this.getFaqs(product_id, this.state.active_page)
      const data = await this.constructData(faqs.results)
      const next = faqs.next
      const prev = faqs.prev
      const totalItemsCount = faqs.count
      this.setState(
        {
          data,
          next,
          prev,
          totalItemsCount
        },
        () => this.setDataTableField(data)
      )
      this.state.data_table.perPage = this.state.page_size
      this.setState({
        loading: false
      })
    } catch (e) {
      console.error(e)
      toast.error('Error loading page')
    }
  }

  constructData(faqs) {
    const permissions = this.state.permissions
    try {
      const data = []
      faqs.map((item) => {
        const row = {
          id: item.id,
          when: item.created_at,
          question: item.question,
          action: (
            <AdminActionRow key={item.id}>
              <AdminEdit onClick={(e) => this.editFAQMgnt(item.id, e)}>
                Edit
              </AdminEdit>
              <AdminDelete onClick={(e) => this.deleteFAQMgnt(item.id, e)}>
                Delete
              </AdminDelete>
            </AdminActionRow>
          )
        }
        data.push(row)
      })
      return data
    } catch (e) {
      console.error(e)
    }
  }

  componentDidMount = async () => {
    try {
      const permissions = Permissions({
        store: this.props.store,
        model: 'finproductfaqs'
      })
      this.setState({ permissions })
      const product_id = this.props.router.query.id
      const faqs = await this.getFaqs(product_id)
      const data = await this.constructData(faqs.results)
      const next = faqs.next
      const prev = faqs.prev
      const totalItemsCount = faqs.count
      this.setState(
        {
          data,
          next,
          prev,
          totalItemsCount
        },
        () => this.setDataTableField(data)
      )
      this.state.data_table.perPage = this.state.page_size
      this.setState({
        loading: false
      })
    } catch (e) {
      console.error(e)
      toast.error('Error loading page')
    }
  }

  editFAQMgnt(faq_id, event) {
    const { store } = this.props
    store.clearFlashData()
    this.props.router.push(
      PAGEURL.UPDATE_FAQ(this.props.router.query.id, faq_id)
    )
    event.preventDefault()
  }

  deleteFAQMgnt(faq_id, event) {
    const confirm = window.confirm(MSG.CONFIRM_DELETE_FAQ)
    if (confirm) {
      this.deleteFaq(faq_id)
    }
    event.preventDefault()
  }

  addFAQ = (event) => {
    const url = PAGEURL.NEW_FAQ(this.props.router.query.id)
    this.props.router.push(url)
  }

  setDataTable(data_table) {
    try {
      const table_object = {}
      table_object.data = data_table.data
      table_object.filteredData = []
      table_object.fields = data_table.fields
      table_object.colLength = data_table.colLength
      table_object.perPage = data_table.perPage
      const filteredData = data_table.data
      const sortColumn = {}
      const coln = { label: '', sortType: '' }
      for (const key in data_table.fields) {
        sortColumn[key] = coln
        sortColumn[key].label = data_table.fields[key]
        sortColumn[key]['sortType'] = ''
      }
      table_object.filteredData = filteredData
      table_object.totalItemsCount = this.state.totalItemsCount
      table_object.sortColumn = sortColumn
      if (table_object.activePage) {
        this.setState({
          data_table: table_object,
          active_page: table_object.activePage
        })
      } else {
        this.setState({ data_table: table_object })
      }
    } catch (e) {
      console.error(e)
    }
  }

  setDataTableField = (
    data,
    active_page = 1,
    perPage = this.state.page_size
  ) => {
    const tableData = {
      data: data,
      fields: {
        when: 'Generated on',
        question: 'Question',
        action: ''
      },
      perPage: perPage,
      colLength: 4
    }
    this.setDataTable(tableData)
  }

  handlePageSizeChange = async (page_size) => {
    this.setState({ page_size: page_size }, async () => {
      const { match } = this.props
      const product_id = match.params.product_id
      const faqs = await this.getFaqs(product_id)
      const data = await this.constructData(faqs.results)
      this.setState(
        {
          data: data,
          filtered_data: data,
          totalItemsCount: faqs.count
        },
        () => {
          this.setDataTableField(this.state.data, 1, page_size)
        }
      )
    })
  }

  handlePaginatorChange = async (pageNumber) => {
    const { match } = this.props
    const product_id = match.params.product_id
    const faqs = await this.getFaqs(product_id, pageNumber)
    const data = await this.constructData(faqs.results)
    this.setState(
      {
        pageNumber: pageNumber,
        data: data,
        filtered_data: data,
        totalItemsCount: faqs.count
      },
      () => {
        this.setDataTableField(this.state.data)
      }
    )
  }

  handlePageChange = async (pageNumber) => {
    window.scrollTo(0, 0)
    try {
      await this.handlePaginatorChange(pageNumber)
      const activePage = parseInt(pageNumber)
      const data_table = this.state.data_table
      data_table.filteredData = data_table.data
      data_table.activePage = activePage
      this.setState({ data_table: data_table, active_page: activePage })
      this.forceUpdate()
    } catch (e) {
      console.error(e)
    }
  }

  dataTableChanged(input) {
    this.setState({ data_table: input })
  }

  currentDisplay = () => {
    const total = this.state.totalItemsCount
    const count = this.state.page_size
    const page = this.state.active_page
    let curr = null
    if (total < count * page) {
      curr = total
    } else {
      curr = count * page
    }
    const page_start = count * page - count
    return `${page_start} - ${curr} of ${total}`
  }

  render() {
    if (this.state.loading) {
      return (
        <div>
          <PageContentLoader />
        </div>
      )
    }
    return (
      <div>
        <div className="content-right-panel">
          <H1 small>
            FAQ Management
            <ActionColumn>
              <AdminButton onClick={this.addFAQ}>
                Add FAQ
              </AdminButton>
            </ActionColumn>
          </H1>
          <div className="right-con-box">
            <div className="tableContent">
              <AdminDataTable
                nextURL={this.state.next}
                prevURL={this.state.prev}
                totalItemsCount={this.state.totalItemsCount}
                handlePaginatorChange={this.handlePaginatorChange}
                handlePageSizeChange={this.handlePageSizeChange}
                dataTableChanged={this.dataTableChanged}
                data_table={this.state.data_table}
                active_page={this.state.active_page}
                handlePageChange={this.handlePageChange}
                currentDisplay={this.currentDisplay}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

FaqMgnt.propTypes = {
  router: PropTypes.object,
  store: PropTypes.object
}

export default withRouter(FaqMgnt)
